import axios from "axios";

const decoderHttp = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export { decoderHttp };